import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import PortalModal from '../../components/common/Modal/PortalModal';
import GenericButton from '../../components/common/GenericButton';
import { CA_ROUTER_LEAVE_LABEL, CA_MODULE_TITLE } from '../../constants';

const currClusterModalStyle = {
  width: '50%',
  left: '25%',
  top: '30%',
};

function RouterLeaveModal({
  routerLeaveModal,
  setRouterLeaveModal,
  confirmNavigation,
}) {
  return (
    <Fragment>
      <PortalModal
        data-test="routerLeaveModal"
        isShowing={routerLeaveModal}
        title={CA_MODULE_TITLE}
        dialogStyles={currClusterModalStyle}
        onCloseClicked={() => {
          setRouterLeaveModal(false);
        }}
      >
        <p>{CA_ROUTER_LEAVE_LABEL}</p>

        <div className="text-center" data-test="saveBeforeCloseComponent">
          <GenericButton
            name="Cancel"
            onBtnClick={() => {
              setRouterLeaveModal(false);
            }}
          />
          <GenericButton
            name="Ok"
            onBtnClick={() => {
              confirmNavigation();
            }}
          />
        </div>
      </PortalModal>
    </Fragment>
  );
}

RouterLeaveModal.propTypes = {
  routerLeaveModal: PropTypes.bool,
  setRouterLeaveModal: PropTypes.func,
};

export default memo(RouterLeaveModal);
